/**
 * Base export
 */
export * from './plugin/lists';
export * from './plugin/dom-node';
export * from './plugin/alignments';
export * from './plugin/indents';
export * from './plugin/formats';
export * from './plugin/link';
export * from './plugin/insert-methods';
export * from './plugin/insert-text';
export * from './plugin/inserthtml-exec';
export * from './plugin/inserthtml';
export * from './plugin/isformatted';
export * from './plugin/ms-word-clean-up';
export * from './plugin/nodecutter';
export * from './plugin/image';
export * from './plugin/selection-commands';
export * from './plugin/selection-exec';
export * from './plugin/clearformat-exec';
export * from './plugin/undo';
export * from './plugin/table';
export * from './plugin/toolbar-status';



//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/node_modules/@syncfusion/ej2-angular-pdfviewer/node_modules/@syncfusion/ej2-richtexteditor/src/editor-manager/plugin.js
// module id = ../../../../@syncfusion/ej2-angular-pdfviewer/node_modules/@syncfusion/ej2-richtexteditor/src/editor-manager/plugin.js
// module chunks = vendor